// Config
import { config } from "../config";
import axios from "axios";

const getexcelResponse = (file) => {
  const url = `${config.apiUrl}/vorgangs/csv-import`;
  const payload = {};

  const requestOptions = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  // sending payload as per required format
  Object.entries(file || {}).forEach(([key, v]) => {
    if (v?.fileBase64) {
      payload[key] = {
        file: v.fileBase64,
        filename: v.fileName || v.file?.name,
      };
    }
  });

  return axios
    .post(url, payload, requestOptions)
    .then((resp) => {
      return resp;
    })
    .catch((error) => {
      return error.response;
    });
};

const dashboardExcelFileDownload = async (requestID) => {
  const url = `${config.apiUrl}/vorgangs/csv/export`;

  try {
    const resp = await axios.post(url, requestID, { responseType: "blob" });
    return resp;
  } catch (error) {
    return error.response;
  }
};

async function getCSVUploadedAndErrorFile() {
  const url = `${config.apiUrl}/vorgangs/csv-import/status`;

  try {
    const resp = await axios.get(url);
    return resp;
  } catch (error) {
    return error;
  }
}

async function getDocumentImportCSVErrorFile(csvUploadId = "dauervollmacht") {
  const url = `${config.apiUrl}/vorgangs/csv-import/${csvUploadId}`;

  try {
    const resp = await axios.get(url, { responseType: "blob" });
    return resp;
  } catch (error) {
    return error;
  }
}

async function closeAndIgnoreCsvDownload(csvUploadId) {
  const url = `${config.apiUrl}/vorgangs/csv-import/${csvUploadId}`;

  try {
    const resp = await axios.delete(url);
    return resp;
  } catch (error) {
    return error;
  }
}

export const csvImportExportService = {
  getexcelResponse,
  dashboardExcelFileDownload,
  getCSVUploadedAndErrorFile,
  getDocumentImportCSVErrorFile,
  closeAndIgnoreCsvDownload,
};
